import AddShetabCard from "../../components/walletReports/addShetabCard";
/**
 * AddShetabCardPage
 *
 * صفحه افزودن کارت شتابی به کیف پول کاربر.
 * رندر کامپوننت AddShetabCard که فرم و مدیریت افزودن کارت را فراهم می‌کند.
 *
 * @returns JSX.Element
 */
// Task Response:
// کد درست است و به درستی کامپوننت AddShetabCard را درون یک div رندر می‌کند.
// می‌توانید div اضافی را حذف کرده و مستقیماً کامپوننت را برگردانید:
const AddShetabCardPage = () => <AddShetabCard />;

export default AddShetabCardPage;
